import ninjaApi from 'store/redux/apis/ninja.api';

export const ninjaAiApi = ninjaApi.injectEndpoints({
  tagTypes: ['AI', 'Conversations'],
  overrideExisting: true,
  endpoints: (builder) => ({
    ninjAi: builder.query({
      query: (body) => ({
        url: '/ai/generate',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Conversations'],
    }),

    conversations: builder.query({
      query: (body) => ({
        url: '/ai/conversations',
        method: 'GET',
        body,
      }),
      providesTags: ['Conversations'],
    }),

    getConversation: builder.mutation({
      query: (body) => ({
        url: `/ai/conversation/${body.id}`,
        method: 'GET',
      }),
      providesTags: ['Conversations'],
    }),

    deleteConversation: builder.mutation({
      query: (body) => ({
        url: `/ai/conversation/${body.id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Conversations'],
    }),
  }),
});

export const {
  useNinjAiQuery,
  useConversationsQuery,
  useDeleteConversationMutation,
  useGetConversationMutation,
} = ninjaAiApi;
